import React from 'react';
import { useFormContext } from '../Provider';
import useValidators from '../Validators/useValidator';
import CommonFieldWrapper from './CommonFieldWrapper';
import Toggle from '../../Button/Toggle';

const Switch = ({label, name, help, onChange, innerLabel, disabled, validators}) => {
    const { formData, updateField, updateValidity, isValidating, isSubmitting, formDisabled } = useFormContext();
    const value = formData[name] ?? '';
    const {isValid, error} = useValidators(value, validators, name, updateValidity);

    const handleChange = (state) => {
        updateField(name, state);
        onChange && onChange(state);
    }

    const isDisabled = formDisabled || disabled || isSubmitting;

    return <CommonFieldWrapper {...{label, name, help, value, isValid, isValidating, error, validators, isDisabled}}>

        <Toggle enabled={value} onChange={handleChange} label={innerLabel ?? label} disabled={isDisabled} hideFocusRing />
        
    </CommonFieldWrapper>
}

export default Switch;